
<div class="change-driver-role main">
  <!-- <p class="header has-text-link" @click="close">
    <i class="fa fa-chevron-left" style="margin-right: 4px" />
    <i>Change Driver Role</i>
  </p> -->
  <div class="field is-grouped">
    <span
      class="button is-medium is-white is-rounded"
      style="padding: 12px"
      @click="close"
    >
      <i class="fa fa-chevron-left fa-lg" />
    </span>
    <div class="control has-icons-right search is-expanded">
      <span
        class="icon is-right"
        style="pointer-events: initial; font-size: 1.3em"
        v-show="searchTerm"
        @click="clearSearch"
      >
        <i class="fa fa-times-circle" />
      </span>
      <input
        ref="input"
        class="input is-rounded is-medium"
        type="text"
        v-model="searchVal"
        :placeholder="searchPlaceholder"
        @keyup="search($event)"
        @focus="search($event)"
        @blur="clearSearch"
      />
    </div>
  </div>
  <div v-if="searchResult.length > 0" class="list is-hoverable search-result">
    <span
      v-for="s in searchResult"
      v-ripple
      class="list-item"
      :key="s.key + s.value"
      @click="chooseBusiness(s.value)"
      >{{ s.key }}
      <i
        v-if="s.value === role.business_id"
        class="fa fa-lock is-pulled-right"
        style="color: pink"
      />
    </span>
  </div>
  <div v-show="showSearching" class="list search-result">
    <span class="list-item">
      <i class="fa fa-spinner fa-spin" />
    </span>
  </div>
  <div v-show="noResults && !showSearching" class="list search-result">
    <span class="list-item is-italic">
      <i>{{ $t("home2.no-results-for") }} "{{ searchTerm }}"</i>
    </span>
  </div>
</div>
